import { Dispatch } from "react";
import { State } from "../../reducers";
import { anularFactura } from "./operaciones.actions";
import { convertDateFormatAnular } from "../../utils/stringDate";

export const anularNotaCredito =
() => async (dispatch: Dispatch<any>, getState: () => State) => {
  const {datosFacturaRes, datosEmisor, formSucursal, calculosArrayProductos} = getState().facturacion;
  const {activeFactura} = getState().historial;
  const {activeDoc} = getState().documentos;
  const receptor = activeFactura?.DetallesDTE?.receptor;

  const anularDoc = {
    documento: datosFacturaRes.JsonFactura,
    sellorecibido: datosFacturaRes.Sello,
    DetallesDTE: {
      receptor: {
        numDocumento: receptor?.numDocumento,
        tipoDocumento: receptor?.tipoDocumento,
        nrc: receptor?.nrc,
        nombre: receptor?.nombre,
        telefono: receptor?.telefono,
        correo: receptor?.correo,
      },
      emisor: {
        nombre: datosEmisor.nombre,
        nit: datosEmisor.nit,
        nrc: datosEmisor.nrc,
        telefono: datosEmisor.telefono,
        correo: datosEmisor.correo,
        tipoEstablecimiento: datosEmisor.tipoestablecimiento,
      },
      resumen: {
        totalIva: calculosArrayProductos.totalImpuesto1,
      },
      identificacion: { 
        tipoDte: activeDoc.idDoc,
        codigoGeneracion: datosFacturaRes.codigoGeneracion,
        numeroControl: "DTE-" + activeDoc.idDoc + "-" + formSucursal.datosSerie.serie + "-" + formSucursal.datosSerie.numeroactual,
        fecEmi: convertDateFormatAnular(datosFacturaRes.fhProcesamiento.split(" ")[0]),
      }
    }
  }

  dispatch(anularFactura([anularDoc]));
}